<template>
  <div class="add-hemorrhage public-content">
    <div class="breadcrumb">创建模板</div>
    <div class="third-title"><span>基础信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="addGroupVo" label-width="190px" :rules="rules" ref="formRef">
        <el-form-item label="模板名称:" prop="groupName">
          <el-input v-model="addGroupVo.groupName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="关联尺寸组:" prop="composeSizeGroup">
          <el-button style="margin-bottom:10px" type="primary" @click="sizeDialog = true" round>选择尺寸组</el-button>
          <el-table v-show="addGroupVo.composeSizeGroup.id" :data="[addGroupVo.composeSizeGroup]" border>
            <el-table-column type="expand">
              <template v-slot='scope'>
                <div style="width:100%;height:100%;background:red">
                  <el-table :data="scope.row.detail.sizeList" border>
                    <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                    <el-table-column label="页面类型" prop="typeName">
                      <template slot-scope="scope"> {{ $store.state.pms.pageType[scope.row.pageTypeCode] }} </template>
                    </el-table-column>
                    <el-table-column label="页面名称" prop="pageName"></el-table-column>
                    <el-table-column label="宽高">
                      <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                    </el-table-column>
                    <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                    <el-table-column label="出血" width="220px">
                      <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{
                        scope.row.bleed.bleedRight }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                    </el-table-column>
                    <el-table-column label="码" prop="barCodeId">
                      <template slot-scope="scope">
                        <p v-for="item in scope.row.barCodeList" :key="item.id">{{ item.barName }}</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="尺寸组名称" prop="groupName"></el-table-column>
            <el-table-column label="尺寸组类" prop="groupCategoryName"></el-table-column>
            <el-table-column label="页面名称" prop="detail.pageName"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="是否关联此尺寸组:">
          <el-switch v-model="addGroupVo.isAssociatedeSizeGroup" :active-value='1' :inactive-value='0' active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="模板是否自动自适应:">
          <el-switch v-model="addGroupVo.photoAdaptation" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)">
          </el-switch>
        </el-form-item>
        <el-form-item label="上传设计版是否弹预览封面:">
          <el-switch v-model="addGroupVo.previewCover" active-color="rgba(20, 115, 230, 1)" inactive-color="rgba(140, 140, 140, 1)" :active-value='1' :inactive-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="模板归属:">
          <el-radio v-model="addGroupVo.groupBelong" :label="0">全部</el-radio>
          <el-radio v-model="addGroupVo.groupBelong" :label="1">平台</el-radio>
        </el-form-item>
        <el-form-item v-if="addGroupVo.groupBelong === 1" label="模板归属平台:">
          <el-button style="margin:0 0 10px 0" @click="queryInfo.pageNum = 1, searchStoreList(), addStoreDialog = true" type="primary" round>添加平台</el-button>
          <el-table border :data="addGroupVo.storeList" style="width: 100%">
            <el-table-column prop="code" label="平台号"></el-table-column>
            <el-table-column prop="name" label="平台名称"></el-table-column>
            <el-table-column prop="storeType" label="平台类型">
              <!-- <template slot-scope="scope">{{ $config.storeType[scope.row.storeType] || scope.row.storeType }}</template> -->
              <template slot-scope="scope">{{ storeType[scope.row.storeType] || scope.row.storeType }}</template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <span @click="addGroupVo.storeList.splice(scope.$index, 1)" class="color-blue">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="关联SKU:">
          <el-button @click="clickAddSku" style="margin-bottom:10px" type="primary" round>关联SKU</el-button>
          <el-table :data="addGroupVo.skuList" style="width: 100%">
            <el-table-column prop="skuName" label="SKU"></el-table-column>
            <el-table-column prop="skuGroupId" label="SKU组id"></el-table-column>
            <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
            <el-table-column prop="spuName" label="产品名称"></el-table-column>
            <el-table-column prop="address" label="SKU组图片">
              <template slot-scope="scope">
                <img style="width:100%" :src="scope.row.skuGroupImage" alt="">
              </template>
            </el-table-column>
            <el-table-column label="模板主图">
              <template slot-scope="scope">
                <!-- <img style="width:100%" :src="scope.row.skuMainImage" alt="" v-if="scope.row.skuMainImage">
                <span class="color-blue" v-else>上传主图</span> -->
                <div style="width:100%;position:relative;" v-if="scope.row.skuMainImage">
                  <img style="width:100%" :src="scope.row.skuMainImage" alt="">
                  <i class="el-icon-circle-close" style="color:#F56C6C;position:absolute;top:2px;right: 2px;z-index: 999;font-size: 18px;" @click="scope.row.skuMainImage = ''"></i>
                </div>
                <div class="upload-img" v-else>
                  <input type="file" name="" id="input_img" @change="fileSize($event, scope.row.id)" />
                  <span class="color-blue">上传主图</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="address" label="操作">
              <template slot-scope="scope">
                <span class="color-blue" @click="addGroupVo.skuList.splice(scope.$index, 1)">删除</span>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </div>
    <div class="form-btn" style="margin: 20px 0">
      <el-button round type="primary" @click="nextStep()" v-preventReClick>下一步</el-button>
    </div>
    <!-- 关联SKU -->
    <el-dialog :close-on-click-modal="false" title="关联SKU" :visible.sync="addSkuDialog" width="70%">
      <el-form :inline="true" :model="templateSearchSkuVO" class="demo-form-inline">
        <el-form-item label="产品名称:">
          <el-input v-model="templateSearchSkuVO.spuName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="SKU名称 :">
          <el-input v-model="templateSearchSkuVO.skuGroupName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="尺寸组:">
          <span>{{ addGroupVo.composeSizeGroup.groupName }}</span>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button @click="getSkuList()" round>查询</el-button>
          <el-button @click="addSku()" type="primary" round>关联</el-button>
        </div>
      </el-form>
      <el-table :data="skuList" @selection-change="handleSkuSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="skuName" label="SKU名称"></el-table-column>
        <el-table-column prop="skuGroupId" label="SKU组id"></el-table-column>
        <el-table-column prop="skuGroupName" label="SKU组名称"></el-table-column>
        <el-table-column prop="spuName" label="产品名称"></el-table-column>
        <el-table-column prop="name" label="SKU组图片">
          <template slot-scope="scope">
            <img style="width:100%" :src="scope.row.skuGroupImage" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="name" label="尺寸组">
          <template>{{ addGroupVo.composeSizeGroup.groupName }}</template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changeSkuPage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
    <!-- 绑定尺寸组 -->
    <el-dialog :close-on-click-modal="false" title="尺寸组" :visible.sync="sizeDialog" width="60%">
      <el-form :inline="true" :model="searchComposeSizeGroupVO" class="demo-form-inline">
        <el-form-item label="尺寸组类:">
          <el-select clearable v-model="searchComposeSizeGroupVO.groupCategoryId" placeholder="">
            <el-option v-for="item in sizeGroupTypeList" :key="item.id" :label="item.categoryName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="尺寸组名称：">
          <el-input v-model="searchComposeSizeGroupVO.groupName" placeholder=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sizeQueryInfo.pageNum = 1, getSizeGroupList()">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="sizeGroupList" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.detail.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName">
                  <template slot-scope="scope"> {{ scope.row.pageTypeCode === 'COVER' ? '封面' : scope.row.pageTypeCode === 'TEXT' ? '内页' : scope.row.pageTypeCode === 'SINGLE' ? '单页' : '未定义' }}
                  </template>
                </el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上方：{{ scope.row.bleed.bleedTop }}mm 下方：{{ scope.row.bleed.bleedBottom }}mm <br> 左侧：{{ scope.row.bleed.bleedLeft }}mm 右侧：{{ scope.row.bleed.bleedRight
                  }}mm <br> 内侧：{{ scope.row.bleed.bleedIn }}mm </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId"></el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="groupCategoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="detail.pageName" min-width="100px"></el-table-column>
        <el-table-column label="操作" min-width="100px">
          <template slot-scope="scope">
            <span class="color-blue" @click="choiceSizeGroup(scope)">选择</span><br>
          </template>
        </el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='sizeChangePage' :queryInfo='sizeQueryInfo'></v-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sizeDialog = false">取 消</el-button>
        <el-button type="primary" @click="sizeDialog = false" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加平台 -->
    <el-dialog :close-on-click-modal="false" title="添加平台" :visible.sync="addStoreDialog" width="70%">
      <el-form :inline="true" :model="searchStoreVo" class="demo-form-inline">
        <el-form-item label="平台号:">
          <el-input v-model="searchStoreVo.code" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台名称:">
          <el-input v-model="searchStoreVo.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="平台类型 :">
          <el-select v-model="searchStoreVo.storeType" placeholder="请选择">
            <el-option v-for="item in storeTypeList" :key="item.id" :label="item.name" :value="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期:">
          <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <div style="float:right;margin-right:20px">
          <el-button round @click="searchStoreList">查询</el-button>
          <el-button type="primary" @click="addStore()" round>添加</el-button>
        </div>
      </el-form>
      <el-table :data="storeList" @selection-change="handleSelectionChange" style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="code" label="平台号"></el-table-column>
        <el-table-column prop="name" label="平台名称"></el-table-column>
        <el-table-column prop="storeType" label="平台类型">
          <!-- <template slot-scope="scope">{{ $config.storeType[scope.row.storeType] || scope.row.storeType }}</template> -->
          <template slot-scope="scope">{{ storeType[scope.row.storeType] || scope.row.storeType }}</template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建日期"></el-table-column>
      </el-table>
      <v-pagination class="v-pagination" @changePage='changePage' :queryInfo='queryInfo'></v-pagination>
    </el-dialog>
  </div>
</template>
<script>
import VPagination from '@/components/Pagination/index.vue'
import { groupListPageing, groupAdd, skuListAssociate, composeGroupDetail, groupCategoryList, storeGetStoreList } from '@/api/pms'
import uploadWebImg, { getAwsSdk } from '@/utils/uploadWebImg'
import { storeTypeGetStoreTypeList } from '@/api/crm'

export default {
  name: 'add-hemorrhage',
  components: {
    VPagination
  },
  data () {
    var checkComposeSizeGroup = (rule, value, callback) => {
      if (this.addGroupVo.composeSizeGroup.id) {
        callback()
      } else {
        callback(new Error('请选择尺寸组'))
      }
    }
    return {
      mainImage: {
        url: ''
      },
      rules: {
        groupName: [
          { required: true, message: '请输入模板组名称', trigger: 'blur' }
        ],
        composeSizeGroup: [
          { validator: checkComposeSizeGroup, trigger: 'blur' }
        ]
      },
      addSkuDialog: false,
      skuList: [],
      templateSearchSkuVO: {
        skuGroupName: '',
        spuName: ''
      },
      selectSkuList: [],
      storeTypeList: [],
      value1: [],
      addStoreDialog: false,
      sizeDialog: false,
      addGroupVo: {
        skuList: [],
        composeSizeGroup: {},
        composeSizeGroupId: '',
        groupBelong: 0,
        groupName: '',
        isAssociatedeSizeGroup: '',
        photoAdaptation: false,
        previewCover: 0,
        storeList: []
      },
      storeList: [],
      searchStoreVo: {
        code: '',
        createTimeBegin: '',
        createTimeEnd: '',
        id: '',
        name: '',
        page: 1,
        storeType: '',
        storeTypeid: ''
      },
      searchComposeSizeGroupVO: {
        groupCategoryId: '',
        groupName: ''
      },
      sizeGroupList: [],
      sizeGroupTypeList: [],
      sizeQueryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      queryInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      storeType: [] // 平台类型
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    if (this.$checkAwsSdk('product')) this.$store.dispatch('awsSdk/getAwsSdk', 'product')
    this.getSizeGroupTypeList()
    this.getSizeGroupList()
  },
  methods: {
    // 上传主图
    fileSize (data, id) {
      let file = data.target.files[0]
      var _this = this
      var reader = new FileReader()
      reader.onload = function (e) {
        var data = e.target.result
        // 加载图片获取图片真实宽度和高度
        var image = new Image()
        image.onload = function () {
          var width = image.width
          var height = image.height
          if (width === height) {
            _this.upload(file, id)
          } else {
            _this.$message.error('图片长宽不相同')
          }
        }
        image.src = data
      }
      reader.readAsDataURL(file)
    },
    // 上传图片
    upload (file, id) {
      console.log('fileType', file.type)
      if (['image/png', 'image/jpg', 'image/jpeg', 'image/webp'].indexOf(file.type) === -1) {
        this.$message.warning('请上传正确的图片格式')
        return
      }
      if (file.size > 1024 * 1024 * 1) {
        this.$message.error('图片大小不能超过1M')
        return
      }
      uploadWebImg(file, this.$store.state.awsSdk.product.s3).then(res => {
        let skuList = this.addGroupVo.skuList.map(element => {
          if (element.id === id) {
            return {
              ...element,
              skuMainImage: res
            }
          } else {
            return element
          }
        })
        this.addGroupVo.skuList = skuList
        console.log('this.addGroupVo.skuList', this.addGroupVo.skuList)
        // this.$forceUpdate()
      })
    },
    choiceSizeGroup (scope) {
      this.addGroupVo.composeSizeGroup = scope.row
      this.$refs.formRef.validateField('composeSizeGroup')
      this.sizeDialog = false
    },
    // 下一步
    nextStep () {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          return
        }

        let obj = {
          composeSizeGroupId: this.addGroupVo.composeSizeGroup.id,
          groupBelong: this.addGroupVo.groupBelong,
          groupName: this.addGroupVo.groupName,
          isAssociatedeSizeGroup: this.addGroupVo.isAssociatedeSizeGroup,
          previewCover: this.addGroupVo.previewCover,
          photoAdaptation: this.addGroupVo.photoAdaptation,
          skuIds: [],
          skuList: [],
          storeIds: []
        }
        let noMainImage = []
        this.addGroupVo.skuList.forEach(item => {
          if (!item.skuMainImage) {
            noMainImage.push(false)
          }
        })
        console.log('noMainImage', noMainImage)
        if (noMainImage.length > 0) {
          this.$message.warning('请上传模板主图')
          return
        }
        this.addGroupVo.storeList.forEach(item => {
          obj.storeIds.push(item.storeId)
        })
        this.addGroupVo.skuList.forEach(item => {
          obj.skuList.push({ skuId: item.id, skuMainImage: item.skuMainImage })
        })
        groupAdd(obj).then(res => {
          if (res.data.success) {
            this.$message.success('继续')
            this.$router.push({ path: '/createtemplategroup2', query: { detail: JSON.stringify(res.data.data) } })
          }
        })
      })
    },
    clickAddSku () {
      if (!this.addGroupVo.composeSizeGroup.id) {
        this.$message.error('未选择尺寸组')
        return
      }
      this.queryInfo.pageNum = 1
      this.getSkuList()
      this.addSkuDialog = true
    },
    // 获取sku列表
    getSkuList () {
      skuListAssociate({ composeSizeGroupId: this.addGroupVo.composeSizeGroup.id, pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, templateSearchSkuVO: this.templateSearchSkuVO }).then(res => {
        if (res.data.success) {
          this.skuList = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    // 添加sku
    addSku () {
      this.addGroupVo.skuList.push(...this.selectSkuList)
      this.addSkuDialog = false
    },
    // 添加平台
    addStore () {
      this.addGroupVo.storeList.push(...this.selectStoreList)
      this.addStoreDialog = false
    },
    // 获取平台类型
    getStoreTypeList () {
      storeTypeGetStoreTypeList().then(res => {
        if (res.data.success) {
          this.storeTypeList = res.data.data
          this.storeType = []
          let storeTypeData = res.data.data
          const montage = (storeTypeData) => {
            let obj = {}
            for (let v of storeTypeData) {
              obj[v.code] = v.name
            }
            return obj
          }
          this.storeType = montage(storeTypeData)
        }
      })
    },
    // 获取尺寸组类
    getSizeGroupTypeList () {
      groupCategoryList().then(res => {
        if (res.data.success) {
          this.sizeGroupTypeList = res.data.data
        }
      })
    },
    // 获取尺寸组信息
    getSizeGroupList () {
      groupListPageing({ pageNum: this.sizeQueryInfo.pageNum, pageSize: this.sizeQueryInfo.pageSize, data: this.searchComposeSizeGroupVO }).then(res => {
        if (res.data.success) {
          let list = res.data.data.records

          this.sizeQueryInfo.total = res.data.data.total
          let num = 0
          if (list.length === 0) {
            this.sizeGroupList = list
            return
          }

          list.forEach(item => {
            composeGroupDetail(item.id).then(res2 => {
              item.detail = res2.data.data
              item.detail.pageName = item.detail.pageName.slice(0, -1)

              num++
              if (num === list.length) {
                console.log(list)
                this.sizeGroupList = list
              }
            })
          })
        }
      })
    },
    // 搜索平台
    searchStoreList () {
      storeGetStoreList({ pageNum: this.queryInfo.pageNum, pageSize: this.queryInfo.pageSize, searchStoreVo: this.searchStoreVo }).then(res => {
        if (res.data.success) {
          this.storeList = res.data.data.records
          this.queryInfo.total = res.data.data.total
        }
      })
    },
    handleSkuSelectionChange (val) {
      this.selectSkuList = val
    },
    handleSelectionChange (val) {
      this.selectStoreList = val
    },
    handleFormatSelectionChange (val) {
      this.selectFormatList = val
    },
    changeSkuPage (val) {
      this.queryInfo = val
      this.getSkuList()
    },
    changePage (val) {
      this.queryInfo = val
      this.searchStoreList()
    },
    sizeChangePage (val) {
      this.sizeQueryInfo = val
      this.getSizeGroupList()
    },
    changeFormatPage (val) {
      this.queryInfo = val
      this.searchFormatList()
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-hemorrhage {
  .spec-mm {
    span {
      margin-right: 10px;
    }

    .el-input {
      width: 110px;
    }

    @{deep} .el-input-group__append {
      padding: 0 15px;
    }
  }

  .link {
    width: 30px;
    height: 30px;
    border: 1px solid #dcdfe6;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-sizing: border-box;

    i {
      font-size: 20px;
      color: #999;
    }
  }

  .active-link {
    background: #1473e6;
    border: 1px solid #1473e6;

    i {
      color: #fff;
    }
  }
}
</style>
